import { Component, Input, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { BaseRichService } from '../../../providers/base-rich.service';
import { BaseListComponent } from '../../shared/base-list/base-list.component';

@Component({
  selector: 'app-audit-trail',
  templateUrl: '../../shared/base-list/base-list.component.html',
  styleUrls: ['./audit-trail.component.scss', '../../shared/base-list/base-list.component.scss']
})
export class AuditTrailComponent extends BaseListComponent implements OnInit {

  @Input() base: any;
  @Input() ref: any;

  constructor(public cookieService: CookieService,
    public activeModal: NgbModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: BaseRichService,
    public router: Router
  ) {
    super(cookieService, activeModal, titleService, translator, service);
    this.entity = 'audit_trail';
  }

  getBody() {
    const body = super.getBody();
    if (this.base && this.ref) {
      body['query'] = [['entity', '=', this.base], 'and', ['ref', '=', this.ref]];
      this.columns = this.columns.filter(c => c.name !== 'entity' && c.name !== 'ref');
      this.subtitle = '_ENTITY';
    }
    return body;
  }

}
